import { render, staticRenderFns } from "./additional-renewal-supervisor-form.component.vue?vue&type=template&id=0464bf02&"
import script from "./additional-renewal-supervisor-form.component.ts?vue&type=script&lang=ts&"
export * from "./additional-renewal-supervisor-form.component.ts?vue&type=script&lang=ts&"
import style0 from "./additional-renewal-supervisor-form.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports